const boxShadows = {
  cardShadow: "0px 1px 4px rgba(69, 37, 28, 0.15)",
  coffeeGlow: "0px 0px 0px 5px rgba(69, 37, 28, 0.25)",
  tagShadow: "0px 0px 2px rgba(69, 37, 28, 0.2)",
  selectedTagShadow: "0px 0px 8px rgba(69, 37, 28, 0.25)",
  textFieldInnerShadow: "inset 0px 2px 2px -1px rgba(74, 74, 104, 0.1)",
  memberRedShade: "0px 0.5px 0px #B11116",
}

export default boxShadows
